/**
 * The three skyPerformance roles (spec §4.3, D2′). `name` is a frozen join key like every other
 * role name: `public.roles.name`, `ROLE_HIERARCHY` and the Users page compare on it literally.
 * Labels come from the vertical pack; keys never change.
 */
export const PERFORMANCE_ROLE_NAMES = {
  employee: "perf_employee",
  manager: "perf_manager",
  hr: "perf_hr",
} as const;

export type PerformanceRoleName =
  (typeof PERFORMANCE_ROLE_NAMES)[keyof typeof PERFORMANCE_ROLE_NAMES];

export const PERFORMANCE_ROLE_NAME_LIST: readonly PerformanceRoleName[] = [
  PERFORMANCE_ROLE_NAMES.employee,
  PERFORMANCE_ROLE_NAMES.manager,
  PERFORMANCE_ROLE_NAMES.hr,
];

export function isPerformanceRoleName(value: unknown): value is PerformanceRoleName {
  return (
    typeof value === "string" && (PERFORMANCE_ROLE_NAME_LIST as readonly string[]).includes(value)
  );
}

/** Lower = more privileged, compared only against other performance roles (spec §4.3). */
export const PERFORMANCE_ROLE_HIERARCHY: Record<PerformanceRoleName, number> = {
  perf_hr: 1,
  perf_manager: 2,
  perf_employee: 3,
};
